import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/molecules/Form";
import { cn } from "@/lib/utils";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { Input, InputProps } from "./Input";

export type InputFieldProps = InputProps & {
  name: string;
  inputClassName?: string;
  label?: React.ReactNode;
  subcopy?: React.ReactNode;
  note?: React.ReactNode;
  placeholder?: string;
};

export const InputField = ({
  prefix,
  suffix,
  testId = "input",
  className,
  inputClassName,
  label,
  subcopy,
  note,
  name,
  fullWidth = false,
  ...inputProps
}: InputFieldProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem
            disabled={inputProps.disabled}
            readOnly={inputProps.readOnly}
            className={cn({ "tw-w-full tw-flex-1": fullWidth }, className)}
          >
            {!!label && (
              <FormLabel subcopy={subcopy} required={inputProps.required}>
                {label}
              </FormLabel>
            )}
            <FormControl>
              <Input
                className={inputClassName}
                prefix={prefix}
                suffix={suffix}
                testId={testId}
                fullWidth={fullWidth}
                {...inputProps}
                {...field}
              />
            </FormControl>
            <FormMessage>{note}</FormMessage>
          </FormItem>
        );
      }}
    />
  );
};

InputField.displayName = "InputField";
